import { combineReducers } from '@reduxjs/toolkit';
import tasks from '@redux/reducers/tasks';
import organizations from '@redux/reducers/organizations';
import workspaceCountersReducer from '@redux/reducers/workspaceCountersReducer';
import workspaceReducer from './workspaceReducer';
import modalReducer from './modalReducer';
import mediaViewerReducer from './mediaViewerReducer';

export const rootReducer = combineReducers({
  organizations,
  workspace: workspaceReducer,
  tasks,
  modal: modalReducer,
  mediaViewer: mediaViewerReducer,
  workspaceCounters: workspaceCountersReducer
});
